// this is an autogenerated file from DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CreateProcedureReceivables/NewTask/Content/Actions/Content/Action/DocumentTemplate/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_EditAutomation_EventActions_Content_EventAction_Content_Content_Content_CreateProcedureReceivables_NewTask_Content_Actions_Content_Action_DocumentTemplate($location_id: uuid!) {
  vaxiom_document_templates(
    where: { organization: { _id: { _eq: $location_id } } }
    order_by: { name: asc_nulls_last }
  ) {
    vaxiom_id: id
    id: _id
    text: name
  }
}

`